// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__7-3ok","errorLogs":"styles_errorLogs__1QtT1"};